import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './search_drawer_header.module.scss';
import { MaterialIcon } from '../../../components/material-icon/MaterialIcon';
import { TextButton } from '../../../components/button';

type Props = {
  closeFilter: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  resetFilters: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  selectedFiltersLength: number;
};

export const SearchDrawerHeader: FC<Props> = ({
  closeFilter,
  selectedFiltersLength,
  resetFilters,
}) => {
  return (
    <div className={styles.header}>
      <button
        type="button"
        className={styles.button}
        title="Retour aux résultats"
        aria-hidden="true"
        onClick={closeFilter}
      >
        <MaterialIcon name="close" className={styles.icon} />
      </button>

      <span className={styles.title}>
        <FormattedMessage id="search/components/search-aside/SearchMobileHeader.tsx/1" />
        <span className={styles.count}>
          {selectedFiltersLength > 0 && ` (${selectedFiltersLength})`}
        </span>
      </span>
      {selectedFiltersLength > 0 && (
        <TextButton onClick={resetFilters}>
          <FormattedMessage id="search/components/search-aside/SearchMobileHeader.tsx/2" />
        </TextButton>
      )}
    </div>
  );
};
